import React from "react";

/**
 * Horizontal scrolling marquee.
 * variant "brand" → electric cyan glowing text (for hero brand tagline)
 * variant "default" → zinc body text (for service-module chips)
 */
export default function Marquee({
  items,
  className = "",
  speed = "marquee",
  variant = "default",
  testid = "marquee",
}) {
  const list = [...items, ...items, ...items];
  const isBrand = variant === "brand";
  return (
    <div
      data-testid={testid}
      className={`relative overflow-hidden border-b border-ink-600 ${
        isBrand ? "bg-[#060609] pt-[72px]" : "bg-[#070709]"
      } ${className}`}
    >
      <div
        className={`flex gap-10 py-4 whitespace-nowrap ${speed} ${
          isBrand ? "opacity-95" : ""
        }`}
      >
        {list.map((it, i) => (
          <div key={i} className="flex items-center gap-10 shrink-0">
            <span
              className={
                isBrand
                  ? "font-mono text-sm md:text-base font-medium uppercase tracking-[0.28em] text-cy [text-shadow:0_0_12px_rgba(0,240,255,0.45)]"
                  : "font-display text-sm md:text-base font-semibold uppercase tracking-[0.22em] text-zinc-300"
              }
            >
              {it}
            </span>
            <span
              className={`w-2 h-2 ${isBrand ? "bg-cy" : "bg-cy"} rotate-45 shrink-0 ${
                isBrand ? "[box-shadow:0_0_8px_rgba(0,240,255,0.6)]" : ""
              }`}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
